import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import { MaterialUIControllerProvider } from "context";
import { StoreProvider } from "easy-peasy";
import store from "./store";
import App from "./App";

ReactDOM.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <StoreProvider store={store}>
        <App />
      </StoreProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
